export default __webpack_public_path__ + "static/media/bookworm-blue.54d92af1.svg";